export class bookingSteps{
    constructor() {
        this.rooms = 'rooms';
        this.customer = 'customer';
        this.confirm = 'confirm';
        this.end = 'end';
    }
};
export default new bookingSteps();